// import React, { useState, useRef, useEffect } from 'react';
// import { Link, useNavigate, useParams } from 'react-router-dom';
// import { 
//   ChevronDown, 
//   CircleHelp, 
//   X, 
//   Building2, 
//   UserCircle2,
//   Sparkles,
//   Users,
//   LogOut,
// } from 'lucide-react';
// import { FaAndroid, FaApple, FaWindows, FaYoutube } from 'react-icons/fa';


// const UserProfile = ({ user }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const { portalName } = useParams();
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
//   const dropdownRef = useRef(null);
//   const buttonRef = useRef(null);
//   const navigate = useNavigate();


//   // Calculate dropdown position for larger screens
//   useEffect(() => {
//     if (isOpen && buttonRef.current && window.innerWidth >= 1024) {
//       const buttonRect = buttonRef.current.getBoundingClientRect();
//       const dropdownWidth = 384; // w-96 = 24rem = 384px
//       const dropdownHeight = 600; // approximate height
//       const padding = 16;

//       let top = buttonRect.bottom + 8;
//       let right = window.innerWidth - buttonRect.right;

//       // Check if dropdown would go off screen bottom
//       if (top + dropdownHeight > window.innerHeight - padding) {
//         // Position above button if not enough space below
//         top = Math.max(padding, buttonRect.top - dropdownHeight - 8);
//       }

//       // Check if dropdown would go off screen left
//       if (buttonRect.right - dropdownWidth < padding) {
//         // Align with left edge of button instead
//         right = window.innerWidth - buttonRect.left - dropdownWidth;
//       }

//       // Ensure dropdown doesn't go off screen right
//       right = Math.max(padding, right);

//       setDropdownPosition({ top, right });
//     }
//   }, [isOpen]);

//   // Get initials from name
//   const getInitials = (firstName, lastName) => {
//     if (!firstName && !lastName) return 'U';
//     const firstInitial = firstName ? firstName[0].toUpperCase() : '';
//     const lastInitial = lastName ? lastName[0].toUpperCase() : '';
//     return firstInitial + lastInitial;
//   };

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
//           buttonRef.current && !buttonRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const handleSignOut = () => {
//     localStorage.clear();
//     navigate("/login");
//   };

//   const handleManageOrganization = () => {
//     setIsOpen(false);
//     navigate(`/${portalName}/my-organization`);
//   };


//   // Shared content component
//   const ProfileContent = ({ isMobile = false }) => (
//     <>
//       {/* User Info */}
//       <div className={`${isMobile ? 'bg-gradient-to-br from-red-50 to-pink-50 rounded-2xl p-6 mb-6' : 'relative overflow-hidden'}`}>
//         {!isMobile && <div className="absolute inset-0 bg-gradient-to-br from-red-500 to-pink-600 opacity-10"></div>}
//         <div className={`${!isMobile ? 'relative p-6 border-b border-gray-100' : ''}`}>
//           {!isMobile && (
//             <button
//               onClick={() => setIsOpen(false)}
//               className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-full transition-colors"
//             >
//               <X className="w-5 h-5 text-gray-400" />
//             </button>
//           )}
          
//           <div className="flex items-start space-x-4">
//             {user?.profilePicture ? (
//               <img 
//                 src={user.profilePicture} 
//                 alt={`${user.firstName} ${user.lastName}`}
//                 className={`${isMobile ? 'w-20 h-20' : 'w-16 h-16'} rounded-full object-cover border-3 border-white shadow-xl`}
//                 onError={(e) => {
//                   e.target.style.display = 'none';
//                   e.target.nextSibling.style.display = 'flex';
//                 }}
//               />
//             ) : null}
//             <div 
//               className={`${isMobile ? 'w-20 h-20 text-2xl' : 'w-16 h-16 text-xl'} rounded-full bg-gradient-to-br from-red-500 to-pink-600 flex items-center justify-center text-white font-bold shadow-xl ${
//                 user?.profilePicture ? 'hidden' : 'flex'
//               }`}
//             >
//               {getInitials(user?.firstName, user?.lastName)}
//             </div>
//             <div className="flex-1 min-w-0">
//               <h3 className={`${isMobile ? 'text-xl' : 'text-lg'} font-bold text-gray-900 truncate`}>
//                 {user?.firstName} {user?.lastName}
//               </h3>
//               <p className="text-sm text-gray-600 font-medium truncate">
//                 {user?.userId || 'User ID'}
//               </p>
//               <p className="text-xs text-gray-500 mt-1 truncate">{user?.email}</p>
//               <span className="inline-flex items-center mt-2 px-2 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">
//                 <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1.5"></span>
//                 Active
//               </span>
//             </div>
//           </div>
          
//           <Link
//             to={`/${portalName}/my-account`}
//             className={`mt-4 block w-full text-center py-3 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-xl ${!isMobile ? 'hover:from-primary hover:to-pink-700 transition-all duration-300 transform hover:scale-[1.02]' : ''} font-medium shadow-lg`}
//             onClick={() => setIsOpen(false)}
//           >
//             <UserCircle2 className="inline-block w-4 h-4 mr-2" />
//             My Account
//           </Link>
//         </div>
//       </div>

//       {/* Organization Section */}
//       <div className={`${isMobile ? 'mb-6' : 'p-4'}`}>
//         <p className={`${isMobile ? '' : 'px-2 py-1'} text-xs font-semibold text-gray-400 uppercase tracking-wider ${isMobile ? 'mb-2' : ''}`}>
//           Organization
//         </p>
//         <button
//           onClick={handleManageOrganization}
//           className={`w-full ${!isMobile ? 'mt-2' : ''} flex items-center justify-between p-4 ${isMobile ? 'bg-gray-50' : ''} hover:bg-gray-${isMobile ? '100' : '50'} rounded-xl transition-all duration-300 group`}
//         >
//           <div className="flex items-center space-x-3">
//             {user?.organization?.organizationPicture ? (
//               <img 
//                 src={user?.organization?.organizationPicture}
//                 alt={user?.organization?.name}
//                 className="w-12 h-12 rounded-xl object-cover shadow-md"
//                 onError={(e) => {
//                   e.target.style.display = 'none';
//                   e.target.nextSibling.style.display = 'flex';
//                 }}
//               />
//             ) : null}
//             <div 
//               className={`w-12 h-12 bg-gradient-to-br from-red-100 to-pink-100 rounded-xl flex items-center justify-center shadow-md ${
//                 user?.organization?.organizationPicture ? 'hidden' : 'flex'
//               }`}
//             >
//               <Building2 className="w-6 h-6 text-primary" />
//             </div>
//             <div className="text-left min-w-0">
//               <p className={`font-semibold text-gray-900 ${!isMobile ? 'group-hover:text-primary transition-colors' : ''} truncate`}>
//                 {user?.organization?.name || 'Organization'}
//               </p>
//               <p className="text-xs text-gray-500">{user?.organization?.plan} Plan</p>
//             </div>
//           </div>
//           <div className={`text-primary ${!isMobile ? 'group-hover:translate-x-1 transition-transform' : ''}`}>
//             →
//           </div>
//         </button>
//       </div>

//       {/* Quick Links */}
//       <div className={`${isMobile ? 'mb-6' : 'px-4 pb-4'}`}>
//         <p className={`${isMobile ? '' : 'px-2 py-1'} text-xs font-semibold text-gray-400 uppercase tracking-wider ${isMobile ? 'mb-2' : ''}`}>
//           Quick Links
//         </p>
//         <div className={`${isMobile ? 'space-y-2' : 'mt-2 space-y-1'}`}>
//           <Link
//             to={`/${portalName}/help`}
//             className={`flex items-center space-x-3 px-4 py-3 ${isMobile ? 'bg-gray-50' : ''} hover:bg-gray-${isMobile ? '100' : '50'} rounded-xl transition-all duration-300 group`}
//             onClick={() => setIsOpen(false)}
//           >
//             <div className={`w-10 h-10 rounded-full bg-red-100 flex items-center justify-center ${!isMobile ? 'group-hover:scale-110 transition-transform' : ''}`}>
//               <CircleHelp className="w-5 h-5 text-primary" />
//             </div>
//             <span className={`text-gray-700 ${!isMobile ? 'group-hover:text-gray-900' : ''} font-medium`}>Help Center</span>
//           </Link>

//           <Link
//             to={`/${portalName}/whats-new`}
//             className={`flex items-center space-x-3 px-4 py-3 ${isMobile ? 'bg-gray-50' : ''} hover:bg-gray-${isMobile ? '100' : '50'} rounded-xl transition-all duration-300 group`}
//             onClick={() => setIsOpen(false)}
//           >
//             <div className={`w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center ${!isMobile ? 'group-hover:scale-110 transition-transform' : ''}`}>
//               <Sparkles className="w-5 h-5 text-blue-600" />
//             </div>
//             <span className={`text-gray-700 ${!isMobile ? 'group-hover:text-gray-900' : ''} font-medium`}>What's New</span>
//           </Link>

//           <Link
//             to={`/${portalName}/community`}
//             className={`flex items-center space-x-3 px-4 py-3 ${isMobile ? 'bg-gray-50' : ''} hover:bg-gray-${isMobile ? '100' : '50'} rounded-xl transition-all duration-300 group`}
//             onClick={() => setIsOpen(false)}
//           >
//             <div className={`w-10 h-10 rounded-full bg-green-100 flex items-center justify-center ${!isMobile ? 'group-hover:scale-110 transition-transform' : ''}`}>
//               <Users className="w-5 h-5 text-green-600" />
//             </div>
//             <span className={`text-gray-700 ${!isMobile ? 'group-hover:text-gray-900' : ''} font-medium`}>Community</span>
//           </Link>
//         </div>
//       </div>

//       {/* Mobile Apps */}
//       <div className={`${isMobile ? 'bg-gray-50 rounded-xl p-4 mb-6' : 'p-4 bg-gray-50'}`}>
//         <p className="text-sm text-gray-600 mb-3 text-center">
//           Get our mobile app
//         </p>
//         <div className="flex items-center justify-center space-x-4">
//           <a href="#j" className={`p-3 ${isMobile ? 'bg-white' : ''} hover:bg-${isMobile ? 'gray-100' : 'white'} rounded-lg transition-all duration-300 ${isMobile ? 'shadow-sm' : 'hover:shadow-md'}`}>
//             <FaAndroid className="w-6 h-6 text-green-600" />
//           </a>
//           <a href="#j" className={`p-3 ${isMobile ? 'bg-white' : ''} hover:bg-${isMobile ? 'gray-100' : 'white'} rounded-lg transition-all duration-300 ${isMobile ? 'shadow-sm' : 'hover:shadow-md'}`}>
//             <FaApple className="w-6 h-6 text-gray-800" />
//           </a>
//           <a href="#j" className={`p-3 ${isMobile ? 'bg-white' : ''} hover:bg-${isMobile ? 'gray-100' : 'white'} rounded-lg transition-all duration-300 ${isMobile ? 'shadow-sm' : 'hover:shadow-md'}`}>
//             <FaWindows className="w-6 h-6 text-blue-600" />
//           </a>
//           <a href="#j" className={`p-3 ${isMobile ? 'bg-white' : ''} hover:bg-${isMobile ? 'gray-100' : 'white'} rounded-lg transition-all duration-300 ${isMobile ? 'shadow-sm' : 'hover:shadow-md'}`}>
//             <FaYoutube className="w-6 h-6 text-primary" />
//           </a>
//         </div>
//       </div>

//       {/* Sign Out */}
//       {isMobile ? (
//         <button
//           onClick={handleSignOut}
//           className="w-full flex items-center justify-center space-x-2 py-4 bg-red-50 text-primary hover:bg-red-100 rounded-xl transition-all duration-300 font-semibold"
//         >
//           <LogOut className="w-5 h-5" />
//           <span>Sign Out</span>
//         </button>
//       ) : (
//         <div className="border-t border-gray-100 p-4">
//           <button
//             onClick={handleSignOut}
//             className="w-full flex items-center justify-center space-x-2 py-3 text-primary hover:bg-red-50 rounded-xl transition-all duration-300 font-medium"
//           >
//             <LogOut className="w-5 h-5" />
//             <span>Sign Out</span>
//           </button>
//         </div>
//       )}
//     </>
//   );

//   return (
//     <div className="relative">
//       {/* Profile Button */}
//       <button
//         ref={buttonRef}
//         onClick={() => setIsOpen(!isOpen)}
//         className="group flex items-center space-x-2 hover:bg-gradient-to-r hover:from-red-50 hover:to-pink-50 rounded-full transition-all duration-300 ease-in-out transform hover:scale-105 pr-2"
//       >
//         <div className="relative">
//           {user?.profilePicture ? (
//             <img 
//               src={user.profilePicture} 
//               alt={`${user.firstName} ${user.lastName}`}
//               className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover border-2 border-white shadow-lg ring-2 ring-red-100 group-hover:ring-red-200 transition-all duration-300"
//               onError={(e) => {
//                 e.target.style.display = 'none';
//                 e.target.nextSibling.style.display = 'flex';
//               }}
//             />
//           ) : null}
//           <div 
//             className={`w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-red-500 to-pink-600 flex items-center justify-center text-white font-bold shadow-lg ${
//               user?.profilePicture ? 'hidden' : 'flex'
//             }`}
//           >
//             {getInitials(user?.firstName, user?.lastName)}
//           </div>
//           <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></div>
//         </div>
//         <span className="hidden md:block text-gray-700 font-medium">
//           {user?.firstName}
//         </span>
//         <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
//       </button>

//       {/* Dropdown Menu */}
//       {isOpen && (
//         <>
//           {/* Overlay */}
//           <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:bg-transparent lg:pointer-events-none" onClick={() => setIsOpen(false)} />
          
//           {/* Mobile and Tablet Menu (< 1024px) */}
//           <div className="lg:hidden fixed inset-0 z-50 overflow-hidden">
//             <div className="h-full flex flex-col bg-white">
//               {/* Header */}
//               <div className="flex-shrink-0 bg-white border-b border-gray-100 p-4 flex items-center justify-between">
//                 <h2 className="text-lg font-semibold">Profile Menu</h2>
//                 <button
//                   onClick={() => setIsOpen(false)}
//                   className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                 >
//                   <X className="w-5 h-5 text-gray-600" />
//                 </button>
//               </div>

//               {/* Scrollable Content */}
//               <div className="flex-1 overflow-y-auto">
//                 <div className="p-4">
//                   <ProfileContent isMobile={true} />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Desktop Menu (>= 1024px) */}
//           <div 
//             ref={dropdownRef}
//             className="hidden lg:block fixed bg-white/95 backdrop-blur-lg rounded-2xl shadow-2xl border border-gray-100 z-50 w-96"
//             style={{
//               top: `${dropdownPosition.top}px`,
//               right: `${dropdownPosition.right}px`,
//               maxHeight: 'calc(100vh - 64px)',
//               overflowY: 'auto'
//             }}
//           >
//             <ProfileContent isMobile={false} />
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default UserProfile;


import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { 
  ChevronDown, 
  CircleHelp, 
  X, 
  Building2, 
  UserCircle2,
  Sparkles,
  Users,
  LogOut,
} from 'lucide-react';
import { FaAndroid, FaApple, FaWindows, FaYoutube } from 'react-icons/fa';

const UserProfile = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { portalName } = useParams();
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const navigate = useNavigate();

  // Calculate dropdown position for larger screens
  useEffect(() => {
    if (isOpen && buttonRef.current && window.innerWidth >= 1024) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const dropdownWidth = 384; // w-96 = 24rem = 384px
      const dropdownHeight = 600; // approximate height
      const padding = 16;

      let top = buttonRect.bottom + 8;
      let right = window.innerWidth - buttonRect.right;

      // Check if dropdown would go off screen bottom
      if (top + dropdownHeight > window.innerHeight - padding) {
        // Position above button if not enough space below
        top = Math.max(padding, buttonRect.top - dropdownHeight - 8);
      }

      // Check if dropdown would go off screen left
      if (buttonRect.right - dropdownWidth < padding) {
        // Align with left edge of button instead
        right = window.innerWidth - buttonRect.left - dropdownWidth;
      }

      // Ensure dropdown doesn't go off screen right
      right = Math.max(padding, right);

      setDropdownPosition({ top, right });
    }
  }, [isOpen]);

  // Get initials from name
  const getInitials = (firstName, lastName) => {
    if (!firstName && !lastName) return 'U';
    const firstInitial = firstName ? firstName[0].toUpperCase() : '';
    const lastInitial = lastName ? lastName[0].toUpperCase() : '';
    return firstInitial + lastInitial;
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Only add the click outside handler for desktop views
    if (window.innerWidth >= 1024) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, []);

  const handleSignOut = () => {
    localStorage.clear();
    navigate("/login");
  };

  const navigateToPage = (path) => {
    // Close the dropdown
    setIsOpen(false);
    
    // Navigate to the specified path
    setTimeout(() => {
      navigate(path);
    }, 50);
  };

  // Shared content component
  const ProfileContent = ({ isMobile = false }) => (
    <>
      {/* User Info */}
      <div className={`${isMobile ? 'bg-gradient-to-br from-red-50 to-pink-50 rounded-2xl p-6 mb-6' : 'relative overflow-hidden'}`} onClick={(e) => e.stopPropagation()}>
        {!isMobile && <div className="absolute inset-0 bg-gradient-to-br from-red-500 to-pink-600 opacity-10"></div>}
        <div className={`${!isMobile ? 'relative p-6 border-b border-gray-100' : ''}`}>
          {!isMobile && (
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-full transition-colors"
            >
              <X className="w-5 h-5 text-gray-400" />
            </button>
          )}
          
          <div className="flex items-start space-x-4">
            {user?.profilePicture ? (
              <img 
                src={user.profilePicture} 
                alt={`${user.firstName} ${user.lastName}`}
                className={`${isMobile ? 'w-20 h-20' : 'w-16 h-16'} rounded-full object-cover border-3 border-white shadow-xl`}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : null}
            <div 
              className={`${isMobile ? 'w-20 h-20 text-2xl' : 'w-16 h-16 text-xl'} rounded-full bg-gradient-to-br from-red-500 to-pink-600 flex items-center justify-center text-white font-bold shadow-xl ${
                user?.profilePicture ? 'hidden' : 'flex'
              }`}
            >
              {getInitials(user?.firstName, user?.lastName)}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className={`${isMobile ? 'text-xl' : 'text-lg'} font-bold text-gray-900 truncate`}>
                {user?.firstName} {user?.lastName}
              </h3>
              <p className="text-sm text-gray-600 font-medium truncate">
                {user?.userId || 'User ID'}
              </p>
              <p className="text-xs text-gray-500 mt-1 truncate">{user?.email}</p>
              <span className="inline-flex items-center mt-2 px-2 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1.5"></span>
                Active
              </span>
            </div>
          </div>
          
          <button 
            onClick={() => navigateToPage(`/${portalName}/my-account`)}
            className={`mt-4 block w-full text-center py-3 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-xl ${!isMobile ? 'hover:from-primary hover:to-pink-700 transition-all duration-300 transform hover:scale-[1.02]' : ''} font-medium shadow-lg`}
          >
            <UserCircle2 className="inline-block w-4 h-4 mr-2" />
            My Account
          </button>
        </div>
      </div>

      {/* Organization Section */}
      <div className={`${isMobile ? 'mb-6' : 'p-4'}`} onClick={(e) => e.stopPropagation()}>
        <p className={`${isMobile ? '' : 'px-2 py-1'} text-xs font-semibold text-gray-400 uppercase tracking-wider ${isMobile ? 'mb-2' : ''}`}>
          Organization
        </p>
        <button
          onClick={() => navigateToPage(`/${portalName}/my-organization`)}
          className={`w-full ${!isMobile ? 'mt-2' : ''} flex items-center justify-between p-4 ${isMobile ? 'bg-gray-50' : ''} hover:bg-gray-${isMobile ? '100' : '50'} rounded-xl transition-all duration-300 group`}
        >
          <div className="flex items-center space-x-3">
            {user?.organization?.organizationPicture ? (
              <img 
                src={user?.organization?.organizationPicture}
                alt={user?.organization?.name}
                className="w-12 h-12 rounded-xl object-cover shadow-md"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : null}
            <div 
              className={`w-12 h-12 bg-gradient-to-br from-red-100 to-pink-100 rounded-xl flex items-center justify-center shadow-md ${
                user?.organization?.organizationPicture ? 'hidden' : 'flex'
              }`}
            >
              <Building2 className="w-6 h-6 text-primary" />
            </div>
            <div className="text-left min-w-0">
              <p className={`font-semibold text-gray-900 ${!isMobile ? 'group-hover:text-primary transition-colors' : ''} truncate`}>
                {user?.organization?.name || 'Organization'}
              </p>
              <p className="text-xs text-gray-500">{user?.organization?.plan} Plan</p>
            </div>
          </div>
          <div className={`text-primary ${!isMobile ? 'group-hover:translate-x-1 transition-transform' : ''}`}>
            →
          </div>
        </button>
      </div>

      {/* Quick Links */}
      <div className={`${isMobile ? 'mb-6' : 'px-4 pb-4'}`} onClick={(e) => e.stopPropagation()}>
        <p className={`${isMobile ? '' : 'px-2 py-1'} text-xs font-semibold text-gray-400 uppercase tracking-wider ${isMobile ? 'mb-2' : ''}`}>
          Quick Links
        </p>
        <div className={`${isMobile ? 'space-y-2' : 'mt-2 space-y-1'}`}>
          <button
            onClick={() => navigateToPage(`/${portalName}/help`)}
            className={`w-full flex items-center space-x-3 px-4 py-3 ${isMobile ? 'bg-gray-50' : ''} hover:bg-gray-${isMobile ? '100' : '50'} rounded-xl transition-all duration-300 group text-left`}
          >
            <div className={`w-10 h-10 rounded-full bg-red-100 flex items-center justify-center ${!isMobile ? 'group-hover:scale-110 transition-transform' : ''}`}>
              <CircleHelp className="w-5 h-5 text-primary" />
            </div>
            <span className={`text-gray-700 ${!isMobile ? 'group-hover:text-gray-900' : ''} font-medium`}>Help Center</span>
          </button>

          <button
            onClick={() => navigateToPage(`/${portalName}/whats-new`)}
            className={`w-full flex items-center space-x-3 px-4 py-3 ${isMobile ? 'bg-gray-50' : ''} hover:bg-gray-${isMobile ? '100' : '50'} rounded-xl transition-all duration-300 group text-left`}
          >
            <div className={`w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center ${!isMobile ? 'group-hover:scale-110 transition-transform' : ''}`}>
              <Sparkles className="w-5 h-5 text-blue-600" />
            </div>
            <span className={`text-gray-700 ${!isMobile ? 'group-hover:text-gray-900' : ''} font-medium`}>What's New</span>
          </button>

          <button
            onClick={() => navigateToPage(`/${portalName}/community`)}
            className={`w-full flex items-center space-x-3 px-4 py-3 ${isMobile ? 'bg-gray-50' : ''} hover:bg-gray-${isMobile ? '100' : '50'} rounded-xl transition-all duration-300 group text-left`}
          >
            <div className={`w-10 h-10 rounded-full bg-green-100 flex items-center justify-center ${!isMobile ? 'group-hover:scale-110 transition-transform' : ''}`}>
              <Users className="w-5 h-5 text-green-600" />
            </div>
            <span className={`text-gray-700 ${!isMobile ? 'group-hover:text-gray-900' : ''} font-medium`}>Community</span>
          </button>
        </div>
      </div>


       {/* Mobile Apps */}
       <div className={`${isMobile ? 'bg-gray-50 rounded-xl p-4 mb-6' : 'p-4 bg-gray-50'}`}>
         <p className="text-sm text-gray-600 mb-3 text-center">
         </p>
           Get our mobile app
         <div className="flex items-center justify-center space-x-4">
           <a href="#j" className={`p-3 ${isMobile ? 'bg-white' : ''} hover:bg-${isMobile ? 'gray-100' : 'white'} rounded-lg transition-all duration-300 ${isMobile ? 'shadow-sm' : 'hover:shadow-md'}`}>
             <FaAndroid className="w-6 h-6 text-green-600" />
           </a>
           <a href="#j" className={`p-3 ${isMobile ? 'bg-white' : ''} hover:bg-${isMobile ? 'gray-100' : 'white'} rounded-lg transition-all duration-300 ${isMobile ? 'shadow-sm' : 'hover:shadow-md'}`}>
             <FaApple className="w-6 h-6 text-gray-800" />
           </a>
           <a href="#j" className={`p-3 ${isMobile ? 'bg-white' : ''} hover:bg-${isMobile ? 'gray-100' : 'white'} rounded-lg transition-all duration-300 ${isMobile ? 'shadow-sm' : 'hover:shadow-md'}`}>
             <FaWindows className="w-6 h-6 text-blue-600" />
           </a>
           <a href="#j" className={`p-3 ${isMobile ? 'bg-white' : ''} hover:bg-${isMobile ? 'gray-100' : 'white'} rounded-lg transition-all duration-300 ${isMobile ? 'shadow-sm' : 'hover:shadow-md'}`}>
             <FaYoutube className="w-6 h-6 text-primary" />
           </a>
         </div>
       </div>

      {/* Sign Out */}
      {isMobile ? (
        <button
          onClick={handleSignOut}
          className="w-full flex items-center justify-center space-x-2 py-4 bg-red-50 text-primary hover:bg-red-100 rounded-xl transition-all duration-300 font-semibold"
        >
          <LogOut className="w-5 h-5" />
          <span>Sign Out</span>
        </button>
      ) : (
        <div className="border-t border-gray-100 p-4" onClick={(e) => e.stopPropagation()}>
          <button
            onClick={handleSignOut}
            className="w-full flex items-center justify-center space-x-2 py-3 text-primary hover:bg-red-50 rounded-xl transition-all duration-300 font-medium"
          >
            <LogOut className="w-5 h-5" />
            <span>Sign Out</span>
          </button>
        </div>
      )}
    </>
  );

  return (
    <div className="relative">
      {/* Profile Button */}
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        className="group flex items-center space-x-2 hover:bg-gradient-to-r hover:from-red-50 hover:to-pink-50 rounded-full transition-all duration-300 ease-in-out transform hover:scale-105 pr-2"
      >
        <div className="relative">
          {user?.profilePicture ? (
            <img 
              src={user.profilePicture} 
              alt={`${user.firstName} ${user.lastName}`}
              className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover border-2 border-white shadow-lg ring-4 ring-primary group-hover:ring-red-50 transition-all duration-300"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div 
            className={`w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-primary to-pink-600 flex items-center justify-center text-white font-bold shadow-lg ${
              user?.profilePicture ? 'hidden' : 'flex'
            }`}
          >
            {getInitials(user?.firstName, user?.lastName)}
          </div>
          <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></div>
        </div>
        <span className="hidden md:block text-textPrimary font-medium hover:text-primary">
          {user?.firstName}
        </span>
        <ChevronDown className={`w-5 h-5 text-textPrimary transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <>
          {/* Overlay - prevents mobile menu from closing when clicked inside */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-50 lg:bg-transparent lg:pointer-events-none" 
            onClick={(e) => {
              // Only close when clicking directly on the overlay, not its children
              if (e.target === e.currentTarget) {
                setIsOpen(false);
              }
            }}
          />
          
          {/* Mobile and Tablet Menu (< 1024px) */}
          <div 
            className="lg:hidden fixed inset-0 z-50 overflow-hidden"
            onClick={(e) => {
              // Make sure clicking the container doesn't close the menu
              e.stopPropagation();
            }}
          >
            <div className="h-full flex flex-col bg-white">
              {/* Header */}
              <div className="flex-shrink-0 bg-white border-b border-gray-100 p-4 flex items-center justify-between">
                <h2 className="text-lg font-semibold">Profile Menu</h2>
                <button
                  onClick={() => setIsOpen(false)}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="w-5 h-5 text-gray-600" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div 
                className="flex-1 overflow-y-auto"
                onClick={(e) => {
                  // Prevent clicks in the content area from closing the menu
                  e.stopPropagation(); 
                }}
              >
                <div className="p-4">
                  <ProfileContent isMobile={true} />
                </div>
              </div>
            </div>
          </div>

          {/* Desktop Menu (>= 1024px) */}
          <div 
            ref={dropdownRef}
            className="hidden lg:block fixed bg-white/95 backdrop-blur-lg rounded-2xl shadow-2xl border border-gray-100 z-50 w-96"
            style={{
              top: `${dropdownPosition.top}px`,
              right: `${dropdownPosition.right}px`,
              maxHeight: 'calc(100vh - 64px)',
              overflowY: 'auto'
            }}
          >
            <ProfileContent isMobile={false} />
          </div>
        </>
      )}
    </div>
  );
};

export default UserProfile;
